import { render } from "./OnlineInputPage.vue?vue&type=template&id=144c4fd2&scoped=true&ts=true"
import script from "./OnlineInputPage.vue?vue&type=script&lang=ts"
export * from "./OnlineInputPage.vue?vue&type=script&lang=ts"

import "./OnlineInputPage.vue?vue&type=style&index=0&id=144c4fd2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src93515913/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144c4fd2"]])

export default __exports__